export { default } from "./ComisionesDeportivaAppGestion";
